import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import { Center, Text } from '@chakra-ui/react';
import { i18n } from '@kcast-fe/core';
class ErrorBoundary extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            hasError: false
        };
    }
    static getDerivedStateFromError(_) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }
    componentDidCatch(error, errorInfo) {
        console.error('Uncaught error:', error, errorInfo);
    }
    render() {
        if (this.state.hasError) {
            return (_jsx(Center, { h: this.props.height ? `${this.props.height}px` : '100%', style: this.props.styles, children: _jsx(Text, { children: this.props.msg || i18n.t('errors.wentWrong') }) }));
        }
        return this.props.children;
    }
}
export { ErrorBoundary };
//# sourceMappingURL=ErrorBoundary.js.map